export default __webpack_public_path__ + "static/media/exitlag.37c81b2e.png";